export default "__VITE_ASSET__BNnjz75o__"